import { FC } from "react";
import { PageWrapper } from "@connectedComponents";
import { InventoryStatusEnum, stackEnum } from "@utilities/enums";
import { useController } from "./useController";
import { Card, GenericActionsBar } from "@components";
import { formatDate } from "@utilities/functions";

export const Inventories: FC = () => {

    const { 
        invertoriesDetails, invertories,
        selectedInventoryFilter,
        goBack, setSearchProduct,
        setSelectedInventoryFilter,
    } = useController();

    return (
        <PageWrapper
            activeStack={stackEnum.stocksStack}
            handleGoBack={goBack}
        >
            <Card
                title="Résumé des inventaires"
                actions={
                    <GenericActionsBar
                        searchPlaceholder="Rechercher un produit..."
                        handleSearch={setSearchProduct}
                        selectedFilterValue={selectedInventoryFilter}
                        handleFilterChange={setSelectedInventoryFilter}
                        filterOptions={[
                            { value: InventoryStatusEnum.COMPLIANT, label: InventoryStatusEnum.COMPLIANT },
                            { value: InventoryStatusEnum.GAP, label: InventoryStatusEnum.GAP },
                        ]}
                    />
                }
            >
                {
                    invertories ? (
                        <div className="space-y-6 min-h-[200px] pt-4">
                            <div className="p-4 bg-base-100 border rounded-lg shadow-sm">
                                <p>Total : <strong>{invertories.summary.totalInventories}</strong></p>
                                <p className="text-success">Conformes : <strong>{invertories.summary.compliant}</strong></p>
                                <p className="text-error">Avec écart : <strong>{invertories.summary.withGap}</strong></p>
                            </div>

                            <hr className="my-4 border-gray-300" />

                            {/* Détails */}
                            <div className="space-y-4">
                                <h3 className="text-lg font-bold text-primary">Historique détaillé</h3>
                                {invertoriesDetails.length === 0 ? (
                                    <p className="text-sm text-gray-500 italic">Aucun inventaire ne correspond à vos filtres actuels.</p>
                                ) : (
                                    invertoriesDetails.map((item, i) => (
                                        <div
                                            key={i}
                                            className="p-4 border rounded-lg bg-white shadow-sm space-y-1"
                                        >
                                            <p className="text-sm text-gray-600"><strong>Produit :</strong> {item.productName}</p>
                                            <p className="text-sm">
                                                <strong>Statut :</strong>{' '}
                                                <span className={`badge ${item.status === InventoryStatusEnum.COMPLIANT ? 'badge-success' : 'badge-error'}`}>
                                                    {item.status}
                                                </span>
                                            </p>
                                            <p className="text-sm">
                                                <strong>Note :</strong> {item.note || '—'}
                                            </p>
                                            <p className="text-xs text-gray-400">
                                                {formatDate(item.createdAt)}
                                            </p>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center justify-center h-32">
                            <p className="text-gray-500">Aucun inventaire disponible.</p>
                        </div>
                    )
                }
            </Card>
        </PageWrapper>
    );
};
